import { render, staticRenderFns } from "./LcsjglList.vue?vue&type=template&id=41db4954&scoped=true&"
import script from "./LcsjglList.vue?vue&type=script&lang=js&"
export * from "./LcsjglList.vue?vue&type=script&lang=js&"
import style0 from "./LcsjglList.vue?vue&type=style&index=0&id=41db4954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db4954",
  null
  
)

export default component.exports